import React, { Dispatch, FC, MutableRefObject, SetStateAction, useEffect, useRef, useState } from "react";
import { View, useWindowDimensions, KeyboardAvoidingView, Platform, TextInput, Animated, Easing, Keyboard } from "react-native";
import { Icon } from "@rneui/base";
import { Theme, ThemeConsumer } from "@rneui/themed";

import { appColors } from "../../themes/appTheme";
import HttpRoutingService from "../../shared/services/httpRoutingService";
import { config } from "../../shared/environment";
import { ZenButton, ZenText } from 'zen-core-elements'


export interface otpData { isVisible: boolean, userData: { countryCode: number, number: string } }
type OtpVerificationModalProps = {
    modalVisible: otpData,
    setModalVisible: Dispatch<SetStateAction<otpData>>
    textRef: MutableRefObject<(TextInput | null)[]>;
};

const AnimatedTextInput = Animated.createAnimatedComponent(TextInput);
const OtpVerificationModal: FC<OtpVerificationModalProps> = ({ setModalVisible, textRef, modalVisible }) => {
    const { width } = useWindowDimensions();
    const [eye, setEye] = useState(false)
    const borderBottomWidthRef = useRef<Animated.Value[]>(Array.from({ length: 4 }, () => new Animated.Value(2)));
    const [otp, setOtp] = useState<string>("")
    let url = `https://uat.zbapps.zenbasket.in/v1/stores/199/users/91/SmsVerification/919080574409`

    const startBlinking = (index: number) => {
        Animated.loop(
            Animated.sequence([
                Animated.timing(borderBottomWidthRef.current[index], {
                    toValue: 0,
                    duration: 250,
                    useNativeDriver: false,
                    easing: Easing.linear
                }),
                Animated.timing(borderBottomWidthRef.current[index], {
                    toValue: 2,
                    duration: 250,
                    useNativeDriver: false,
                    easing: Easing.linear
                })
            ]),
            { iterations: -1 }
        ).start();
    };

    useEffect(() => {
        Keyboard?.addListener("keyboardDidHide", () => {
            textRef?.current?.forEach((data) => data?.blur())
        })
        sendOTP()
    }, [])
    const sendOTP = async () => {
        const url = HttpRoutingService?.replaceUrl('stores/{storeId}/users/{countryCode}/SmsVerification/{phoneNumber}', { storeId: config?.storeId, countryCode: modalVisible?.userData?.countryCode, phoneNumber: modalVisible?.userData?.number })
        await HttpRoutingService?.getMethod(url, null, "v1/").then((response) => {
        }).catch((error) => {
            console.log("otp error", error?.response?.data?.error)
        })
    }

    const stopBlinking = (index: number) => {
        borderBottomWidthRef.current[index]?.stopAnimation();
        borderBottomWidthRef.current[index].setValue(2);
    };

    const focusFn = (index: number) => {
        startBlinking(index);
        textRef.current[index]?.setNativeProps({
            style: { borderBottomColor: appColors.lightDark }
        });
    };

    const blurFn = (index: number) => {
        stopBlinking(index);
        textRef.current[index]?.setNativeProps({
            style: { borderBottomColor: appColors.lightGrey }
        });
    };

    return (
        <ThemeConsumer>
            {({ theme }: { theme: Theme }) => (
                <KeyboardAvoidingView behavior={Platform.OS === "ios" ? "padding" : undefined} enabled>
                    <View style={[theme?.modifierSetStyle?.innerView, { width: width > 900 ? "60%" : width > 600 ? "80%" : "90%" }]}>
                        <View style={theme?.modifierSetStyle?.modelHeader}>
                            <ZenText content={"Mobile Number Verification"} bold size={width > 600 ? theme?.mediumFontSize : theme?.smallerFontSize} color={theme?.dark} />
                            <Icon name="close-circle" type="material-community" size={width > 600 ? 24 : 22} color={theme?.iconColor}
                                onPress={() => setModalVisible((prev) => {
                                    let { isVisible, userData } = prev
                                    isVisible = false
                                    return { isVisible, userData }
                                })} />
                        </View>
                        <View style={[theme?.modifierSetStyle?.contentView, { paddingTop: 0, paddingHorizontal: width > 600 ? 20 : 10, justifyContent: "center", height: 80 }]}>
                            <View style={{ alignSelf: "center", width: "80%" }}>
                                <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                    {Array.from({ length: 4 }).map((_, index) => (
                                        <AnimatedTextInput
                                            ref={(el) => (textRef.current[index] = el as TextInput | null)}
                                            key={index}
                                            // value={eye ? textRef.current[index]?.props?.value : "*"}
                                            value={eye ? otp[index] : (otp[index] ? "*" : " ")}
                                            returnKeyType={index < 3 ? "next" : "done"}
                                            onSubmitEditing={() => {
                                                if (index < 3) {
                                                    textRef.current[index + 1]?.focus();
                                                }
                                            }}

                                            blurOnSubmit={index < 3 ? false : true}
                                            onFocus={() => focusFn(index)}
                                            onBlur={() => blurFn(index)}
                                            cursorColor={theme?.light}
                                            onKeyPress={({ nativeEvent: { key: keyValue } }) => {
                                                if (keyValue === "Backspace") {
                                                    if (!textRef.current[index]?.props?.value) {
                                                        textRef.current[index - 1]?.focus();
                                                    }
                                                    // textRef.current[index]?.setNativeProps({ text: "" });
                                                    setOtp((prev) => {
                                                        let data = [...prev]
                                                        data[index] = ""
                                                        return data?.join("")
                                                    })
                                                } else {
                                                    // textRef.current[index]?.setNativeProps({ text: keyValue });
                                                    setOtp((prev) => {
                                                        let data = [...prev]
                                                        data[index] = keyValue
                                                        return data?.join("")
                                                    })
                                                    textRef.current[index + 1]?.focus();
                                                }
                                            }}
                                            maxLength={1}
                                            textAlign="center"
                                            keyboardType="number-pad"
                                            style={{
                                                borderBottomWidth: borderBottomWidthRef.current[index],
                                                borderBottomColor: theme?.lightGrey,
                                                width: 40,
                                                height: 40,
                                                fontSize: eye ? theme?.largerFontSize : theme?.headerFontSize,
                                                color: theme?.dark,
                                                fontFamily: theme?.bold,

                                            }}
                                            textContentType={"oneTimeCode"}
                                            autoComplete={"one-time-code"}
                                        />
                                    ))}
                                    <Icon name={eye ? "eye" : "eye-off"} type="material-community" color={theme?.grey} onPress={() => { setEye(!eye) }} />
                                </View>
                            </View>
                        </View>
                        <View style={{ alignSelf: "center", marginBottom: 10 }}>
                            <ZenButton
                                title={"Verify"}
                                titleColor={theme?.light}
                                disabled={otp?.length == 4 ? false : true}
                                backGroundColor={theme?.primary}
                                buttonStyle={[theme?.receiptSettingsStyle?.previewButtonStyle, { paddingHorizontal: width > 600 ? 20 : 10, backgroundColor: theme?.primary }]}
                                onPress={() => { }}
                            />
                        </View>
                    </View>
                </KeyboardAvoidingView>
            )}
        </ThemeConsumer>
    );
};

export default OtpVerificationModal;
